import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type DashboardMode = 'BUYER' | 'SELLER';

interface ModeState {
  mode: DashboardMode | null;
  userId: string | null;
  setMode: (m: DashboardMode, userId: string) => void;
}

/**
 * Which dashboard view (Buying/Selling) is currently shown - a display
 * choice, not a permission; the backend already lets any account buy or
 * sell regardless of role. Persisted so a page reload keeps whichever view
 * you were on, but tagged with the account id that set it - consumers must
 * check `userId` matches the signed-in user before trusting `mode`, so a
 * different account logging in on the same browser never inherits a stale
 * mode left by someone else.
 */
export const useDashboardMode = create<ModeState>()(
  persist(
    (set) => ({
      mode: null,
      userId: null,
      setMode: (mode, userId) => set({ mode, userId }),
    }),
    { name: 'souqli-dashboard-mode' },
  ),
);
